// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3zIMV","row":"styles_row__V9dfw"};